<template>
  <v-text-field
    v-model="inputValue"
    :rules="rules"
    outlined
    density="compact"
  ></v-text-field>
</template>

<script>
import validator from "@/helper/validator";
export default {
  name: "passportNumberCard",
  props: {
    modelValue: String,
  },
  data: () => ({
    rules: [validator.required, validator.passport],
  }),
  computed: {
    inputValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>
